var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6813 12.1418V4.36096C21.6813 4.08341 21.5711 3.81723 21.3748 3.62097C21.1786 3.42471 20.9124 3.31445 20.6348 3.31445H2.32092C2.04337 3.31445 1.77719 3.42471 1.58093 3.62097C1.38467 3.81723 1.27441 4.08341 1.27441 4.36096V18.5935C1.27441 18.871 1.38467 19.1372 1.58093 19.3335C1.77719 19.5297 2.04337 19.64 2.32092 19.64H16.5874M1.27441 7.10072H21.6813",
    stroke: "#0E2B3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5354 20.6858C19.6258 20.3525 20.5966 19.7113 21.3312 18.8393C22.0658 17.9672 22.5327 16.9015 22.6759 15.7704C22.7463 14.7653 22.7404 13.7564 22.6581 12.7523C22.6471 12.594 22.5775 12.4456 22.463 12.3359C22.3484 12.2262 22.1971 12.1631 22.0386 12.1589C20.887 12.2094 19.7608 11.8111 18.897 11.048C18.8006 10.9531 18.6709 10.9 18.5356 10.9C18.4004 10.9 18.2707 10.9531 18.1743 11.048C17.3105 11.8111 16.1843 12.2094 15.0327 12.1589C14.8742 12.1631 14.7229 12.2262 14.6083 12.3359C14.4938 12.4456 14.4242 12.594 14.4132 12.7523C14.3309 13.7564 14.325 14.7653 14.3954 15.7704C14.5385 16.9015 15.0054 17.9671 15.7399 18.8392C16.4743 19.7112 17.4451 20.3525 18.5354 20.6858ZM18.5354 20.6858V10.8994",
    stroke: "#0E2B3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector1.390060d596825031146a595e5c32190f.svg";
export { ForwardRef as ReactComponent };